var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPitanga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_3512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3987 5.06907C15.3987 5.06907 15.3987 5.06907 15.3987 5.06907C16.3478 4.8682 17.2091 4.43895 17.9233 3.84079C18.902 3.02109 19.6043 1.8842 19.8776 0.583137C19.9407 0.282546 19.7113 0 19.4042 0H18.2872C15.4459 0 12.8981 1.62595 11.6728 4.11219C11.6728 4.11218 11.6728 4.11219 11.6728 4.11219C11.6345 4.18993 11.5974 4.26849 11.5618 4.34789L11.5589 4.35423C11.5329 4.4122 11.5076 4.47061 11.4831 4.52943C11.411 4.70193 11.3451 4.87809 11.2857 5.05768C11.2857 5.05767 11.2857 5.05768 11.2857 5.05768C11.2641 5.12323 11.2433 5.18926 11.2233 5.25572C11.143 5.52364 11.3153 5.78221 11.5625 5.83827C11.6246 5.85236 11.6915 5.85366 11.7602 5.83911L15.3987 5.06907Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7032 5.47243C9.69477 5.2619 9.72076 5.04403 9.78656 4.8247C9.9135 4.40158 10.07 3.9935 10.2535 3.60243C9.8939 3.53821 9.47879 3.5 9 3.5C7.45446 3.5 6.57245 3.89812 6.08049 4.28415C7.04213 4.70348 8.11665 5.26912 8.99994 5.99161C9.2247 5.80771 9.46092 5.63475 9.7032 5.47243Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14325 6.51426C6.02204 6.44229 4.89269 6.63275 3.90564 7.31362C2.19433 8.49408 1.5 10.7312 1.5 13.6775C1.5 15.8127 1.78839 17.5038 2.45714 18.7644C0.933909 17.7175 0 15.7919 0 12.2581C0 7.46947 1.46123 5.56422 4.07144 5.1118C4.34518 5.20617 4.64985 5.31772 4.97146 5.44636C5.68476 5.73168 6.45154 6.08958 7.14325 6.51426Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5429 18.7644C16.2116 17.5038 16.5 15.8127 16.5 13.6775C16.5 10.7312 15.8057 8.49408 14.0944 7.31362C13.9174 7.19156 13.7359 7.08526 13.5507 6.99341L15.7092 6.53656C15.946 6.48645 16.1785 6.42504 16.406 6.35292C17.4443 7.44837 18 9.30491 18 12.2581C18 15.7919 17.0661 17.7175 15.5429 18.7644Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98996 19.9999C8.10792 19.9889 7 18.5223 7 14.5C7 10.4624 8.11634 9 9 9C9.88366 9 11 10.4624 11 14.5C11 18.5223 9.89208 19.9889 9.01004 19.9999H8.98996Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56183 19.8863C4.46315 19.566 3 18.3436 3 13.6775C3 8.97802 4.89236 7.71345 7.45976 8.05142C6.94534 8.45803 6.56063 9.03975 6.29952 9.62311C5.79078 10.7597 5.5 12.369 5.5 14.5C5.5 16.631 5.79078 18.2403 6.29952 19.3769C6.37623 19.5483 6.46362 19.7195 6.56183 19.8863Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13.6775C15 18.3436 13.5368 19.566 11.4382 19.8863C11.5364 19.7195 11.6238 19.5483 11.7005 19.3769C12.2092 18.2403 12.5 16.631 12.5 14.5C12.5 12.369 12.2092 10.7597 11.7005 9.62311C11.4394 9.03975 11.0547 8.45803 10.5402 8.05142C13.1076 7.71345 15 8.97802 15 13.6775Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_3512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitanga);
export default __webpack_public_path__ + "static/media/pitanga.73cd75e00ce999b7e8db7a808249ba55.svg";
export { ForwardRef as ReactComponent };